// extracted by mini-css-extract-plugin
module.exports = {"DateFields":"ManualEntryForm_DateFields__JZcs7","PrecisionLabel":"ManualEntryForm_PrecisionLabel__2G7rR","ArrowWrapper":"ManualEntryForm_ArrowWrapper__x5kRw"};